import { Edge } from '@xyflow/react';

export const getConnectPortFromEdge = (edge: Edge, targetNodeId: string) => {
  const targetId = edge.targetHandle?.includes(targetNodeId)
    ? edge.targetHandle
    : edge.sourceHandle;
  const port = targetId?.split('__')[1];
  return port || '';
};
